export const CDN_BASE_URL = `https://prod-cdn-candy-hoover.mktg-port.he.services/haier/static/custom`;
